// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root___-OwT","row":"Node_row__1gNUk","label":"Node_label__2nGVg","footer":"Node_footer__CsxHM"};